import { useEffect } from 'react';
import apiNet from '../newApi/apiNet.ts';
import { MainLayout } from '../components/layouts/MainLayout.tsx';

const ReverbFavoritesTest = () => {
    useEffect(() => {
        apiNet.reverbFavoritesTest().then(r => {
            console.log("test reverb api response", r);
        });
    }, []);
    return (
        <MainLayout isFooterVisible={true} contentPadding='p-2 pt-16 md:pt-0'>
            ok
        </MainLayout>
    );
};

export default ReverbFavoritesTest;